export const cx = (...classes) => classes.filter(Boolean).join(" ");

// Ancho de las pantallas de admin con tablas de datos. Deliberadamente amplio:
// encerrar una tabla de 6+ columnas en un contenedor angosto la vuelve ilegible.
export const ADMIN_PAGE_WIDTH = "max-w-[1740px]";
